import { render, staticRenderFns } from "./CF7Produtos.vue?vue&type=template&id=4cf5e6b9&"
import script from "./CF7Produtos.vue?vue&type=script&lang=js&"
export * from "./CF7Produtos.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./CF7Produtos.vue?vue&type=style&index=1&id=4cf5e6b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports